// extracted by mini-css-extract-plugin
export default {"heading":"Pm-z","createAccount":"Qm-z","disabled":"Rm-z","copy":"Sm-z","terms":"Tm-z"};